import { useQueryClient, useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { authHeader } from "@/utils/headers";
import { displayToast } from "@/utils/toast";
import { ToastType } from "@/enums/toast";

export const useDeleteDatasetGroup = (userToken: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (datasetGroupId: number) =>
      fetch(`${ENDPOINTS.dataset_groups}/${datasetGroupId}`, {
        method: "DELETE",
        headers: authHeader(userToken),
      }),
    {
      onSuccess: () => {
        displayToast("Dataset group deleted successfully", ToastType.success);
        queryClient.invalidateQueries([ENDPOINTS.dataset_groups]);
        queryClient.invalidateQueries(["dataset-groups"]);
      },
    },
  );
};
